function hasText(value) {
  return Boolean(String(value || "").trim());
}

function check(label, done, required = true) {
  return { label, done: Boolean(done), required };
}

function buildSteps(form = {}, productsEnabled = true) {
  const business = form.business || {};
  const theme = form.theme || {};
  const hero = form.hero || {};
  const catalog = form.catalog || {};
  const sections = form.sections || {};
  const about = form.about || {};
  const highlights = Array.isArray(form.highlights) ? form.highlights : [];
  const contact = form.contact || {};
  const seo = form.seo || {};

  const steps = [
    {
      id: "identity",
      label: "Identidad del negocio",
      shortLabel: "Identidad",
      description: "Nombre, descripción, logo y colores principales.",
      checks: [
        check("Nombre del negocio", hasText(business.name)),
        check("Descripción breve", hasText(business.shortDescription)),
        check("Logo principal", hasText(theme.logoUrl), false),
        check("Paleta definida", hasText(theme.primaryColor) && hasText(theme.secondaryColor)),
      ],
      actions: [
        { type: "section", section: "identity", label: "Editar datos" },
        { type: "settings", tab: 0, label: "Editar colores" },
        { type: "settings", tab: 1, label: "Cargar logos" },
      ],
    },
    {
      id: "hero",
      label: "Portada principal",
      shortLabel: "Portada",
      description: "El primer mensaje, imagen y acción que ve el visitante.",
      checks: [
        check("Título principal", hasText(hero.title)),
        check("Texto de apoyo", hasText(hero.subtitle)),
        check("Imagen o slider", hasText(hero.imageUrl) || Boolean(hero.slides?.length), false),
        check("Botón principal", hasText(hero.primaryCtaLabel) && hasText(hero.primaryCtaUrl)),
      ],
      actions: [{ type: "section", section: "hero", label: "Editar portada" }],
    },
  ];

  if (productsEnabled) {
    steps.push({
      id: "catalog",
      label: "Productos o servicios",
      shortLabel: "Catálogo",
      description: "Presentación y organización de lo que ofrece el negocio.",
      checks: [
        check("Catálogo visible", sections.showProducts !== false || sections.showFeatured !== false),
        check("Mensaje principal del catálogo", hasText(catalog.featured?.title)),
        check(
          "Catálogo organizado",
          sections.showCategories === true || sections.showBrands === true || catalog.spotlight?.enabled === true,
          false
        ),
      ],
      actions: [
        { type: "section", section: "featured", label: "Editar presentación" },
        { type: "section", section: "categories", label: "Editar categorías" },
      ],
    });
  }

  steps.push(
    {
      id: "trust",
      label: "Confianza y diferenciales",
      shortLabel: "Confianza",
      description: "Historia del negocio y motivos concretos para elegirlo.",
      checks: [
        check("Título institucional", hasText(about.title)),
        check("Historia o descripción", hasText(about.description)),
        check(
          "Dos diferenciales claros",
          highlights.filter((item) => hasText(item?.title) && hasText(item?.description)).length >= 2
        ),
      ],
      actions: [
        { type: "section", section: "about", label: "Editar presentación" },
        { type: "section", section: "highlights", label: "Editar diferenciales" },
      ],
    },
    {
      id: "contact",
      label: "Contacto",
      shortLabel: "Contacto",
      description: "Canales reales para que el visitante pueda avanzar.",
      checks: [
        check("Canal de contacto", hasText(business.whatsapp) || hasText(business.phone) || hasText(business.email)),
        check("Título de contacto", hasText(contact.title)),
        check("Mensaje de WhatsApp", hasText(contact.whatsappMessage), false),
      ],
      actions: [
        { type: "settings", tab: 3, label: "Completar datos" },
        { type: "section", section: "contact", label: "Editar bloque" },
      ],
    },
    {
      id: "publish",
      label: "Publicación",
      shortLabel: "Publicar",
      description: "Título para buscadores, descripción y estado público.",
      checks: [
        check("Título para Google", hasText(seo.title)),
        check("Descripción para Google", hasText(seo.description)),
        check("Sitio publicado", form.publicStatus === "published"),
      ],
      actions: [{ type: "settings", tab: 4, label: "Revisar publicación" }],
    }
  );

  return steps.map((step) => ({
    ...step,
    done: step.checks.every((item) => item.required === false || item.done),
  }));
}

export function getSiteBuilderProgress(form = {}, productsEnabled = true) {
  const steps = buildSteps(form, productsEnabled);
  const requiredChecks = steps.flatMap((step) => step.checks.filter((item) => item.required !== false));
  const completedChecks = requiredChecks.filter((item) => item.done).length;
  const percentage = requiredChecks.length
    ? Math.round((completedChecks / requiredChecks.length) * 100)
    : 100;

  return {
    steps,
    percentage,
    completedChecks,
    totalChecks: requiredChecks.length,
    complete: steps.every((step) => step.done),
  };
}

const SECTION_STEP = {
  identity: "identity",
  navbar: "identity",
  footer: "identity",
  hero: "hero",
  spotlight: "catalog",
  products: "catalog",
  featured: "catalog",
  featuredProducts: "catalog",
  categories: "catalog",
  brands: "catalog",
  about: "trust",
  highlights: "trust",
  contact: "contact",
  floatingWhatsapp: "contact",
};

export function findStepForSection(sectionId, productsEnabled = true) {
  const stepId = SECTION_STEP[sectionId] || "publish";
  const steps = buildSteps({}, productsEnabled);
  return steps.find((step) => step.id === stepId) || steps[steps.length - 1] || null;
}
